import ResourceCard, { ResourceCardProps } from '@/components/_atoms/ResourceCard';
import { mediaBreakpointUp } from '@/styles/layout/utils';
import { FONT_WEIGHTS } from '@/styles/typography';
import { customTextSize, remCalc } from '@/styles/typography/utils';
import { FC } from 'react';
import styled from 'styled-components';

export interface ResourceCardsProps {
  heading?: string;
  resources: (ResourceCardProps & { key?: string | number })[];
}

const ResourceCards: FC<ResourceCardsProps> = (props) => {
  return (
    <SectionContainer>
      {props.heading && <SectionHeading>{props.heading}</SectionHeading>}

      <CardGrid count={props.resources.length}>
        {props.resources.map((card) => (
          <ResourceCard {...card} key={card.key ?? card.title} />
        ))}
      </CardGrid>
    </SectionContainer>
  );
};

export default ResourceCards;

// Styled Components

const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${remCalc(30)};

  ${mediaBreakpointUp('tablet')} {
    gap: ${remCalc(40, 20)};
  }

  ${mediaBreakpointUp('desktop')} {
    gap: ${remCalc(60, 20)};
  }
`;

const SectionHeading = styled.h3`
  font-weight: ${FONT_WEIGHTS.SEMIBOLD};
  text-align: center;
  ${customTextSize(24, 34)};

  ${mediaBreakpointUp('desktop')} {
    ${customTextSize(32, 38)};
    letter-spacing: -0.01em;
  }
`;

const CardGrid = styled.div<{ count: number }>`
  display: grid;
  grid-auto-rows: auto;
  gap: inherit;

  ${mediaBreakpointUp('tablet')} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${mediaBreakpointUp('desktop')} {
    grid-template-columns: repeat(${(props) => (props.count === 4 ? 4 : 3)}, 1fr);
  }
`;
